<div>
  <div style="margin-left: 50%; margin-bottom: 2%;">

     <button class="noPrint" style="margin-right: 2%; margin-left: 2%"
              (click)="exportExcel('Vatnaval_View_Data')" mat-raised-button color="primary">
              Export
            </button>
    <!-- <button class="noPrint" style="margin-left: 10px" mat-raised-button color="primary" printSectionId="print-section"
      ngxPrint>
      Print
    </button> -->

    <button class="noPrint"
        style="margin-right: 2%; margin-left: 2%"
        mat-raised-button color="primary"
        (click)="printPage()">
         Print
       </button>

    <button mat-dialog-close class="btn noPrint">Close</button>
  </div>

  <div class="container">
    <div id="print-section">

      <div class="row">
        <div class="col-3">
          <img src="../../../assets/img/brand/red.png" alt="logo" width="100" height="100">
        </div>
        <div class="col-6" style="margin-top: 25px;">
          <span style="font-size: 18px;">
            हिंदुस्थान प्रकाशन संस्था <br>
            116-119, शिल्पीन सेंटर, पहिला मजला, गं. द. आंबेकर मार्ग, <br>
            वडाळा, मुंबई - 400 031 दूरध्वनीः 9967570531
          </span>

        </div>
        <div class="col-3" style="margin-top: 15px;">
          <span style="font-size: 17px;">दिनांक - {{ startDate | date:'dd/MM/yyyy' }}</span>
        </div>
      </div>

      <!-- TABLE -->
      <table border="1" width="100%" style="margin-top: 15px; border-collapse: collapse; text-align: center;">

        <!-- HEADER ROW -->
        <thead>
          <tr>
            <th [attr.colspan]="4 + sundayDates.length + 9" style="text-align: center; color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
              हस्ते वाटणावळ - {{ getMonthNameMarathi(month) }} {{ year }}</th>
          </tr>
          <tr>
            <th style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">अ.क्र</th>
            <th style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">प्रतिनिधीचे नाव</th>
            <th style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">ठिकाण</th>
            <th style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">वाटणावळ दर</th>

            <!-- ✅ Dynamic Sundays -->
            <th *ngFor="let sunday of sundayDates" style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{ sunday }}
            </th>

            <th style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">अंक संख्या</th>
            <th style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">वाटणावळ रक्कम</th>
            <th style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">मागील वाटणावळ</th>
            <th style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">मागील थकबाकी</th>
            <th style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">एकूण वाटणावळ</th>
            <th style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">अकाऊंट पेमेंट</th>
            <th style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">अकाऊंट शिल्लक वाटणावळ</th>
            <th style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">अकाऊंट दिनांक</th>
            <th style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">शेरा</th>

            
          </tr>
        </thead>

        <!-- BODY -->
        <tbody>
           <tr *ngFor="let item of VatnavalViewData; let i = index">

            <td style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ i + 1 }}</td>
            <td style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ item.issue_Seller_Name }}</td>
            <td style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ item.place }}</td>
            <td style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ item.vatnaval_Rate }}</td>

            <td *ngFor="let sunday of sundayDates" style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
              {{ item[sunday] || 0 }}
            </td>
            
            <td style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ item.total_Ank || 0 }}</td>
            <td style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ item.vatnaval_Total || 0}}</td>
            <td style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ item.previous_Vatnaval || 0 }}</td>
            <td style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ item.description }}</td>
            <td style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ item.all_Vatnaval_Amount || 0 }}</td>
            <td style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ item.payment_Type  || 0}}</td>
            <td style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ item.remaining_Account_Amount || 0 }}</td>
            <td style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ item.account_Sign }}</td>
            <td style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ item.description1}}</td>

           

          </tr> 
        </tbody>

        <!-- FOOTER TOTAL -->
        <tfoot>
  <tr style="font-weight: bold; background: #f2f2f2;">
    
    <td colspan="4" style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">एकूण</td>

    <!-- ✅ Sunday totals -->
    <td *ngFor="let sunday of sundayDates" style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
      {{ getSundayTotal(sunday) }}
    </td>

    <td style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ getTotalAnk() }}</td>
    <td style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ getVatnavalTotal() }}</td> 
    <td style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ getPreviousTotal() }}</td> 
    <td style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ getAllPastDueAmount() }}</td>
    <td style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ getAllVatnavalTotal() }}</td> 
    <td style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{getAccountPaymentAmount() }}</td> 
    <td style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ getAllRemainingTotal() }}</td>
    <td style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;"></td>
    <td style="color: black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;"></td>

  </tr>
</tfoot>

      </table>

      <!-- ✅ Signature Section -->
      <div style="display: flex; justify-content: flex-end; margin-top: 10px;">

        <div style="text-align: center; width: 250px;">

          <!-- Space for signature -->
          <div style="height: 10px;"></div>

          <!-- Signature Label -->
          <div style="font-weight: 600; color: black;">
            स्वाक्षरी
          </div>

          <!-- Department Head -->
          <div style="margin-top: 50px; color: black;">
            वर्गणी विक्री विभाग
          </div>

          <!-- Date -->
          <div style="margin-top: 5px; color: black;">
            दिनांक: {{ today | date:'dd/MM/yyyy' }}
          </div>

        </div>

      </div>

    </div>




  </div>
</div>